var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dinput-checkbox"},[_c('sl-checkbox',{attrs:{"true-value":_vm.trueValue,"false-value":_vm.falseValue},model:{value:(_vm.response.value),callback:function ($$v) {_vm.$set(_vm.response, "value", $$v)},expression:"response.value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }